<div class="">
    <span class="tw-text-[#7B7575]"
        >{{ searchResults.length }} {{ "FAQ.MATCHES" | translate }}</span
    >
    <div
        class="tw-flex tw-flex-col tw-gap-[30px] tw-mt-[50px] tw-max-w-[600px]"
    >
        <div
            class="tw-border-b tw-border-b-gray-400 tw-pb-[20px]"
            *ngFor="let item of searchResults"
        >
            <div class="tw-flex tw-items-center tw-gap-[10px]">
                <p class="!tw-text-[#7B7575] !tw-text-[14px] !tw-mb-0">
                    {{
                        selectedLanguage === "en"
                            ? item.categoryEn
                            : item.categoryBm
                    }}
                </p>
                <p
                    *ngIf="item.subCatEn || item.subCatBm"
                    class="!tw-text-[#7B7575] !tw-text-[14px] !tw-mb-0"
                >
                    |
                </p>
                <p
                    *ngIf="item.subCatEn || item.subCatBm"
                    class="!tw-text-[#7B7575] !tw-text-[14px] !tw-mb-0"
                >
                    {{
                        selectedLanguage === "en"
                            ? item.subCatEn
                            : item.subCatBm
                    }}
                </p>
            </div>
            <h2
                (click)="searchForQuestion(item)"
                class="!tw-font-semibold !tw-text-[20px] !tw-text-black hover:tw-cursor-pointer"
            >
                {{
                    selectedLanguage == "en" ? item.questionEn : item.questionBm
                }}
            </h2>
            <p
                (click)="searchForQuestion(item)"
                class="!tw-text-[#7B7575] hover:tw-cursor-pointer"
            >
                {{
                    selectedLanguage == "en"
                        ? stripHtml(item.answerEn)
                        : stripHtml(item.answerBm)
                }}
            </p>
        </div>
    </div>
</div>
